import { useMemo } from "react";
import type { ReactNode } from "react";
import type { Permissions, Uuid } from "../api";
import { WalletContext } from "./context";
import type { WalletLinks } from "./context";

export type WalletProviderProps = {
  walletId: Uuid;
  companyId: Uuid;
  permissions: Permissions;
  links: WalletLinks;
  children: ReactNode;
};

/** Pose le portefeuille courant pour les écrans en dessous. */
export function WalletProvider({ walletId, companyId, permissions, links, children }: WalletProviderProps) {
  const value = useMemo(
    () => ({ walletId, companyId, permissions, links }),
    [walletId, companyId, permissions, links],
  );
  return <WalletContext.Provider value={value}>{children}</WalletContext.Provider>;
}
